import { render, staticRenderFns } from "./Foto.vue?vue&type=template&id=e99d7da6&"
import script from "./Foto.vue?vue&type=script&lang=js&"
export * from "./Foto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports